<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      v-if="!loading && !form.id"
      class="alert alert-danger"
    >
      <div class="alert-body">
        <p>You are not authorized to access this form. If you think you should have access, contact the administration.</p>
      </div>
    </div>
    <div
      v-if="!loading && form.id"
      class="content-wrapper"
    >
      <div v-if="canEdit">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <div class="row breadcrumbs-top">
              <div class="col-12">
                <h2 class="content-header-title float-start mb-0">
                  {{ form.title }}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <p v-html="form.description" />
        <p>Deadline: <strong>{{ form.end_date }}</strong></p>
        <div
          class="content-body content-body--senior-call"
        >
          <div class="row">
            <div class="col-12">

              <!-- title section -->
              <div class="card card__request__form">
                <div class="card-content">
                  <div class="card-body">
                    <FormSection
                      v-for="block in form.blocks"
                      :key="block.id"
                      :block="block"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="page-actions">
            <button
              id="type-success"
              class="btn btn-success"
              :class="{'d-none': submit}"
              @click="sendForm(true)"
            >
              <i data-feather="save" /> Save & Send
            </button>
            <button
              id="type-success"
              class="ms-1 btn btn-success"
              :class="{'d-none': submit}"
              @click="sendForm(false)"
            >
              <i data-feather="save" /> Save
            </button>
            <button
              class="btn btn-outline-success"
              type="button"
              disabled=""
              :class="{'d-none': !submit}"
            >
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              <span class="ms-25 align-middle">Sending...</span>
            </button>
          </div>

        </div>
      </div>
      <div v-else class="card card__request__form">
        <div class="card-content">
          <div class="card-body">
            <h1 class="cart-title text-danger">
              You no longer can access this form. If you want to modify its content, please contact Isabel at igracia@icrea.cat.  
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import FormSection from './partials/FormSection.vue'
import { can } from '@/@core/libs/acl/utils';

export default {
  components: {
    FormSection,
  },
  data() {
    return {
      slug: this.$route.params.form,
      loading: true,
      submit: false,
    }
  },
  computed: {
    ...mapGetters({
      form: 'requestForms/item',
    }),
    hasPendingRequired() {
      return this.form.blocks.filter(e => {
        const canSee = this.canSeeBlock(e)
        return e.required && (e.type !== 'date_hour' ? (!e.answer || e.answer.length === 0) : this.isValidDate(e)) && canSee
      })
    },
    canEdit() {
      let canEdit = true;

      this.form.blocks.forEach(block => {
        if(block.is_sent) {
          canEdit = false;
        }
      });

      return canEdit;
    }
  },
  async mounted() {
    await this.$store.dispatch('requestForms/fetchSlug', this.slug)
    this.setLoading(false)

    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    canSeeBlock(block) {
      if (block.relations && block.relations.length > 0 && this.form.blocks) {
        let hasRelation = false

        const groups = {}
        block.relations.forEach(relation => {
          if (relation.group) {
            groups[relation.group] = {
              used: 0,
              total: groups[relation.group] ? groups[relation.group].total + 1 : 1,
            }
          }
        })

        block.relations.forEach(relation => {
          // If relation without group is already found, skip
          if (hasRelation) return

          // If the relation doesn't have a group, use the usual logic
          if (!relation.group) {
            hasRelation = this.form.blocks.filter(e => {
              let matchAnswer = false
              const { answer } = e

              if (answer && Array.isArray(answer)) {
                const option = relation.options.find(o => answer.includes(o.id))
                if (option) {
                  matchAnswer = answer.findIndex(f => f === option.id) !== -1
                }
              } else if (answer) {
                const option = relation.options.find(o => o.id === answer)
                matchAnswer = option && option.id === answer
              }

              return e.id === relation.block.id && matchAnswer
            }).length > 0
          }

          // If the relation has a group, all relations in the group must match
          if (relation.group) {
            const blocks = this.form.blocks.filter(e => {
              let matchAnswer = false
              const { answer } = e

              if (answer && Array.isArray(answer)) {
                const option = relation.options.find(o => answer.includes(o.id))
                if (option) {
                  matchAnswer = answer.findIndex(f => f === option.id) !== -1
                }
              } else if (answer) {
                const option = relation.options.find(o => o.id === answer)
                matchAnswer = option && option.id === answer
              }

              return e.id === relation.block.id && matchAnswer
            })

            if (groups[relation.group]) {
              groups[relation.group].used = groups[relation.group].used + blocks.length
            }
          }
        })

        // If any group has all its relations matched, set hasRelation to true
        if (Object.values(groups).some(e => e.used === e.total && e.used > 0)) {
          hasRelation = true
        }

        return hasRelation
      }

      return true
    },
    isValidDate(date) {
      const required = []
      if (date.date && !date.answer_date) {
        required.push('date')
      }

      if (date.hour && !date.answer_hour) {
        required.push('hour')
      }

      return required.length > 0
    },
    setLoading(loading) {
      this.loading = loading
    },
    async sendForm(send = false) {
      this.submit = true

      if (this.hasPendingRequired.length > 0 && send) {
        Vue.swal('Required sections pending to be answered', this.hasPendingRequired.map(e => e.title).join('<br>'), 'warning')
      } else {
        const data = { ...this.form }
        this.form.is_sent = send
        await this.$store.dispatch('requestForms/answerForm', this.form)
        data.blocks.forEach(e => {
          if (e.type === 'upload' && e.answer) {
            Vue.prototype.$saveFiles([e.answer])
          }
        })

        if(send) {
          this.$router.push({ name: 'request-forms.ok' })
        }
      }

      this.submit = false
    },
  },
}
</script>
